var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Detalle de Preparación" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.epc.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.epc.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.epc, "value", $$v)
                                  },
                                  expression: "formFields.epc.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticStyle: { display: "none" },
                              attrs: { xs4: "", sm4: "", md4: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.serieactivanro.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.serieactivanro.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivanro,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.serieactivanro.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.fecha_alta.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.fecha_alta.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fecha_alta,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fecha_alta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.arriendo.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.arriendo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.arriendo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.arriendo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _vm.formFields.serieactivaplata_ingresada.value ==
                              "S"
                                ? _c("v-checkbox", {
                                    attrs: {
                                      label:
                                        _vm.formFields
                                          .serieactivaplata_ingresada.label,
                                      disabled: _vm.modoVer
                                    },
                                    model: {
                                      value:
                                        _vm.formFields
                                          .serieactivaplata_ingresada.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields
                                            .serieactivaplata_ingresada,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.serieactivaplata_ingresada.value"
                                    }
                                  })
                                : _vm._e(),
                              _vm.formFields.serieactivaplata_ingresada.value ==
                              "N"
                                ? _c("v-checkbox", {
                                    attrs: {
                                      label:
                                        _vm.formFields
                                          .serieactivaplata_ingresada.label,
                                      disabled: _vm.modoVer
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.activacion.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.activacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.plataforma_activa.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.plataforma_activa.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.plataforma_activa,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.plataforma_activa.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.id_dispositivo.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.id_dispositivo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.id_dispositivo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.id_dispositivo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.avl.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.avl.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.avl, "value", $$v)
                                  },
                                  expression: "formFields.avl.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.simserienumero.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.simserienumero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.simserienumero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.simserienumero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.simmovil.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.simmovil.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.simmovil,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.simmovil.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.telconame.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.telconame.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.telconame,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.telconame.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.telcoplanname.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.telcoplanname.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.telcoplanname,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.telcoplanname.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.estado.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.estado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.estado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.estado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.vehiculo_patente.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.vehiculo_patente.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.vehiculo_patente,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.vehiculo_patente.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.fecha_baja.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.fecha_baja.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fecha_baja,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fecha_baja.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.obs.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.obs.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.obs, "value", $$v)
                                  },
                                  expression: "formFields.obs.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }